<div class="sidebar" data-testid="separated-files-sidebar">
  <div class="sidebar-header">
    <h3>Separated Files</h3>
    <div class="progress-indicator">
      <div class="progress-bar-container">
        <div class="progress-bar-fill" [style.width.%]="(approved_count / total_count) * 100"></div>
      </div>
      <span class="progress-count">{{ approved_count }}/{{ total_count }}</span>
    </div>
    <p class="progress-text" data-testid="progress-text">
      Review and approve each file
    </p>
  </div>

  <div class="sidebar-content">
    <div class="file-list">
      <div 
        *ngFor="let doc of separated_documents; let i = index" 
        class="file-item"
        [class.selected]="isSelected(doc.doc_id)"
        [class.approved]="doc.is_approved"
        [attr.data-testid]="'file-item-' + (i + 1)"
        (click)="selectDocument(doc.doc_id)">
        
        <div class="file-icon">
          <svg *ngIf="!doc.is_approved" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14,2 14,8 20,8"></polyline>
          </svg>
          <svg *ngIf="doc.is_approved" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="approved-icon">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14,2 14,8 20,8"></polyline>
            <polyline points="9,12 11,14 16,9"></polyline>
          </svg>
        </div>
        
        <div class="file-info">
          <span class="file-name">{{ doc.display_name }}</span>
          <span class="page-count">{{ doc.page_count }} pages</span>
        </div>
        
        <div class="file-status">
          <span *ngIf="doc.is_approved" class="approved-badge">✓ Approved</span>
        </div>
      </div>
    </div>
  </div>
</div>
